import { Instrument } from "../types"
import {
  CustomText,
  FlexInstrumentCardContainer,
  InstrumentCardContainer,
  InstrumentCardDivider,
  TickerText,
} from "./InstrumentCard.styled"

interface IInstrumentCardProps {
  index: number
  instrument: Instrument
}

const InstrumentCard = ({ index, instrument }: IInstrumentCardProps) => {
  return (
    <InstrumentCardContainer index={index}>
      <FlexInstrumentCardContainer justifyContent="space-between" alignItems="center" gap="5px">
        <TickerText>{instrument.bloomberg_code}</TickerText>
        <InstrumentCardDivider />
        <CustomText>BB-Unique {instrument.bb_unique}</CustomText>
        <InstrumentCardDivider />
        <CustomText>Exchange {instrument.exchange.name}</CustomText>
        <InstrumentCardDivider />
        <CustomText>Currency {instrument.currency.name}</CustomText>
      </FlexInstrumentCardContainer>
    </InstrumentCardContainer>
  )
}

export default InstrumentCard
